<template>
    <div @mouseleave="onMouseLeave">
        <!-- 侧边导航 -->
        <div class="navBox">
            <div class="navList bgf_navList">
                <el-popover placement="left-start" trigger="hover" :open-delay="200">

                    <slot>
                        <div class="chatBox cursor" @click.stop="openLink">
                            <p>chat online</p>
                        </div>
                    </slot>
                    <div slot="reference" class="list cursor" :class="navIndex == 1 ? 'selList' : ''"
                        @click.stop="openLink" @mouseover="onMouseOver(1)">
                        <div class="icon">
                            <img v-if="navIndex == 1" src="../assets/nav/1.png" alt="">
                            <img v-else src="../assets/nav/8.png" alt="">
                        </div>
                        <p>{{ i18n.nav.chat }}</p>
                    </div>
                </el-popover>
                <el-popover placement="left-start" trigger="hover" offset="120" :open-delay="200">
                    <slot>
                        <div class="whatsappBox">
                            <img v-for="(item, index) in $store.state.navInfo.WhatsApp"
                                :src="$store.state.imgurl + item" alt="" :key="index">
                        </div>
                    </slot>
                    <div slot="reference" class="list cursor" :class="navIndex == 2 ? 'selList' : ''"
                        @click="navClick(2)" @mouseover="onMouseOver(2)">
                        <!--  'https://wa.me/' + $store.state.navInfo.WechatCode[0] -->
                        <div v-show="0">|</div>
                        <a v-if="$store.state.navInfo.WechatCode"
                            :href="`https://api.whatsapp.com/send/?phone=%2B8613598128846&text&type=phone_number&app_absent=0`"
                            target="_blank">
                            <div class="icon">
                                <img v-if="navIndex == 2" src="../assets/nav/9.png" alt="">
                                <img v-else src="../assets/nav/2.png" alt="">
                            </div>
                            <p>{{ i18n.nav.whatsapp }}</p>
                        </a>
                    </div>
                </el-popover>
                <el-popover placement="left-start" trigger="hover" offset="120" :open-delay="200">
                    <slot>
                        <div class="wechatBox">
                            <img v-for="(item, index) in $store.state.navInfo.Wechat" :src="$store.state.imgurl + item"
                                alt="" :key="index">
                        </div>
                    </slot>

                    <div slot="reference" class="list cursor" :class="navIndex == 3 ? 'selList' : ''"
                        @click="navClick(3)" @mouseover="onMouseOver(3)">
                        <div class="icon">
                            <img v-if="navIndex == 3" src="../assets/nav/10.png" alt="">
                            <img v-else src="../assets/nav/3.png" alt="">
                        </div>
                        <p>{{ i18n.nav.wechat }}</p>
                    </div>
                </el-popover>
                <el-popover placement="left-start" trigger="hover" :open-delay="200">
                    <slot>
                        <div class="chatBox mailBox">
                            <p v-for="(item, index) in $store.state.navInfo.Email" :key="index">
                                <a :href="'mailto:' + item" target="_blank" class="clicka">{{ item }}</a>
                            </p>
                        </div>
                    </slot>
                    <div slot="reference" class="list cursor" :class="navIndex == 4 ? 'selList' : ''"
                        @mouseover="onMouseOver(4)">
                        <a v-if="$store.state.navInfo.Email" :href="'mailto:' + $store.state.navInfo.Email[0]"
                            target="_blank" @click="navClick(4)">
                            <div class="icon">
                                <img v-if="navIndex == 4" src="../assets/nav/11.png" alt="">
                                <img v-else src="../assets/nav/4.png" alt="">
                            </div>
                            <p>{{ i18n.foot.email }}</p>
                        </a>
                    </div>
                </el-popover>
                <el-popover placement="left-start" trigger="hover" :open-delay="200">
                    <div slot="reference" class="list cursor" :class="navIndex == 5 ? 'selList' : ''" @click="goMessage"
                        @mouseover="onMouseOver(5)">
                        <div class="icon">
                            <img v-if="navIndex == 5" src="../assets/nav/12.png" alt="">
                            <img v-else src="../assets/nav/5.png" alt="">
                        </div>
                        <p>{{ i18n.nav.message }}</p>
                    </div>
                </el-popover>
                <el-popover placement="left-start" trigger="hover" :open-delay="200">
                    <slot>
                        <div class="chatBox telBox">
                            <p v-for="(item, index) in $store.state.navInfo.Tel" :key="index">
                                <!-- 'tel:' + e -->
                                <a v-for="(e, i) in (api.strToarr(item))" :key="i"
                                    :href="`https://api.whatsapp.com/send/?phone=%2B8613598128846&text&type=phone_number&app_absent=0`"
                                    class="clicka" style="display: block;">{{ e }}</a>
                            </p>
                        </div>
                    </slot>
                    <div slot="reference" class="list cursor" :class="navIndex == 6 ? 'selList' : ''"
                        @mouseover="onMouseOver(6)">
                        <!-- 'tel:' + $store.state.navInfo.Tel[0] -->
                        <a v-if="$store.state.navInfo.Tel"
                            :href="`https://api.whatsapp.com/send/?phone=%2B8613598128846&text&type=phone_number&app_absent=0`"
                            target="_blank" @click="navClick(6)">
                            <div class="icon">
                                <img v-if="navIndex == 6" src="../assets/nav/13.png" alt="">
                                <img v-else src="../assets/nav/6.png" alt="">
                            </div>
                            <p>{{ i18n.nav.tel }}</p>
                        </a>
                    </div>
                </el-popover>
                <div class="list cursor" :class="navIndex == 7 ? 'selList' : ''" @click="scrollToTop"
                    @mouseover="onMouseOver(7)">
                    <div class="icon">
                        <img v-if="navIndex == 7" src="../assets/nav/14.png" alt="">
                        <img v-else src="../assets/nav/7.png" alt="">
                    </div>
                    <p>{{ i18n.nav.top }}</p>
                </div>
            </div>
        </div>
        <div class="navBoxH">
            <div class="navList">
                <div class="list cursor" :class="navIndex == 1 ? 'selList' : ''" @click="openMess">
                    <div class="icon">
                        <img v-if="navIndex == 1" src="../assets/nav/1.png" alt="">
                        <img v-else src="../assets/nav/8.png" alt="">
                    </div>
                    <p>{{ i18n.nav.chat }}</p>
                </div>
                <div class="list cursor" :class="navIndex == 2 ? 'selList' : ''" @click="navClick(2)">
                    <div class="icon">
                        <img v-if="navIndex == 2" src="../assets/nav/9.png" alt="">
                        <img v-else src="../assets/nav/2.png" alt="">
                    </div>
                    <p>{{ i18n.nav.whatsapp }}</p>
                </div>
                <div class="list cursor" :class="navIndex == 3 ? 'selList' : ''" @click="navClick(3)">
                    <div class="icon">
                        <img v-if="navIndex == 3" src="../assets/nav/10.png" alt="">
                        <img v-else src="../assets/nav/3.png" alt="">
                    </div>
                    <p>{{ i18n.nav.wechat }}</p>
                </div>
                <div class="list cursor" :class="navIndex == 4 ? 'selList' : ''" @click="navClick(4)">
                    <div class="icon">
                        <img v-if="navIndex == 4" src="../assets/nav/11.png" alt="">
                        <img v-else src="../assets/nav/4.png" alt="">
                    </div>
                    <p>{{ i18n.foot.email }}</p>
                </div>
                <div class="list cursor" :class="navIndex == 5 ? 'selList' : ''" @click="goMessage">
                    <div class="icon">
                        <img v-if="navIndex == 5" src="../assets/nav/12.png" alt="">
                        <img v-else src="../assets/nav/5.png" alt="">
                    </div>
                    <p>{{ i18n.nav.message }}</p>
                </div>
                <div class="list cursor" :class="navIndex == 6 ? 'selList' : ''" @click="navClick(6)">
                    <div class="icon">
                        <img v-if="navIndex == 6" src="../assets/nav/13.png" alt="">
                        <img v-else src="../assets/nav/6.png" alt="">
                    </div>
                    <p>{{ i18n.nav.tel }}</p>
                </div>
                <!-- <div class="list cursor" :class="navIndex == 7?'selList':''"  @click="scrollToTop">
                    <div class="icon">
                        <img v-if="navIndex == 7" src="../assets/nav/14.png" alt="">
                        <img v-else src="../assets/nav/7.png" alt="">
                    </div>
                    <p>{{i18n.nav.top}}</p>
                </div> -->
            </div>
        </div>
        <div class="infoBox">
            <div class="chatBox cursor" v-if="navIndex == 1" @click.stop="openLink">
                <p>chat online</p>
            </div>
            <div class="whatsappBox" v-if="navIndex == 2">
                <img v-for="(item, index) in $store.state.navInfo.WhatsApp" :src="$store.state.imgurl + item" alt=""
                    :key="index">
            </div>
            <div class="wechatBox" v-if="navIndex == 3">
                <img v-for="(item, index) in $store.state.navInfo.Wechat" :src="$store.state.imgurl + item" alt=""
                    :key="index">
            </div>
            <div class="chatBox mailBox" v-if="navIndex == 4">
                <p v-for="(item, index) in $store.state.navInfo.Email" :key="index">
                    <a :href="'mailto:' + item" target="_blank" class="clicka">{{ item }}</a>
                </p>
            </div>
            <div class="chatBox telBox" v-if="navIndex == 6">
                <p v-for="(item, index) in $store.state.navInfo.Tel" :key="index">
                    <!-- 'tel:' + e -->
                    <a v-for="(e, i) in (api.strToarr(item))" :key="i"
                        :href="`https://api.whatsapp.com/send/?phone=%2B8613598128846&text&type=phone_number&app_absent=0`"
                        class="clicka" style="display: block;">{{ e }}</a>
                </p>
            </div>
        </div>
        <div class="messageLink" v-if="linkSta">
            <div class="close cursor">
                <span @click="linkSta = false">×</span>
            </div>
            <iframe
                src="https://only.qrf-alloy.com/chat/index?noCanClose=1&token=a8526ca5c579d376424bff72adac2857"></iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: "navBox",
    components: {},
    data() {
        return {
            navIndex: 0,
            linkSta: false
        };
    },
    watch: {},
    computed: {
        i18n() {
            return this.$t("message");
        },
    },
    methods: {
        openLink() {
            this.linkSta = true;
            this.navIndex = 0;
        },
        openMess() {
            this.navIndex = 1;
            window.open('https://only.qrf-alloy.com/chat/index?noCanClose=1&token=a8526ca5c579d376424bff72adac2857')
        },
        navClick(num) {
            this.navIndex = num;
        },
        onMouseOver(num) {
            this.navIndex = num;
        },
        onMouseLeave() {
            this.navIndex = 0;
        },
        goMessage() {
            this.navIndex = 5;
            this.$router.push(`/contact-us`);
        },
        // 返回顶部事件
        scrollToTop() {
            this.navIndex = 7;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
    },
    beforeCreate() { },
    created() {

    },
    destroyed() { },
    beforeMount() { },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    activated() { },
    deactivated() { },
};
</script>
<style lang="less" scoped>
.messageLink {
    width: 400px;
    height: 60vh;
    position: fixed;
    right: 30px;
    bottom: 80px;
    z-index: 9999;
    background: #FFFFFF;

    .close {
        font-size: 30px;
        text-align: right;
        padding: 0 10px;
    }

    iframe {
        width: 100%;
        height: 100%;
    }
}

.navBox {
    position: fixed;
    right: 0;
    top: 200px;
    z-index: 9999;
}

.navBoxH {
    display: none;
}

.navList {
    .list {
        // cccccc
        width: 120px;
        height: 110px;
        background: rgba(255, 255, 255, 0.28);
        box-sizing: border-box;
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.16);
        color: #333333;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;

        .icon {
            width: 30px;
            height: 30px;
            margin-bottom: 5px;

            img {
                width: 30px;
                height: 30px;
            }
        }

        a {
            width: 82px;
            height: 76px;
            color: #333333;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }
    }

    .selList {
        font-size: 16px;
        color: #FFFFFF;
        background: #003089;
        box-sizing: border-box;
        border-width: 0px 0px 1px 0px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.16);

        a {
            color: #FFFFFF;
        }
    }
}

.infoBox {
    display: block;
}

.chatBox {
    color: #2268EB;
    font-size: 15px;
    padding: 20px 30px;
    line-height: 1;
    border-radius: 15px 13px 0px 13px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);

    p {
        font-size: 24px;
    }
}

.whatsappBox {
    padding: 10px;
    border-radius: 15px 13px 0px 13px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);

    img {
        width: 150px;
        height: 150px;
    }
}

.wechatBox {
    padding: 10px;
    border-radius: 15px 13px 0px 13px;
    background: #FFFFFF;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);

    img {
        width: 150px;
        height: 150px;
    }
}

@media screen and (max-width: 1024px) {
    .navBox {
        display: none;
        position: fixed;
        right: 30px;
        top: 150px;
        z-index: 9999;
    }

    .navBoxH {
        display: block;
        position: fixed;
        right: 0;
        bottom: 0;
        z-index: 9999;
        width: 100%;
    }

    .navList {
        display: flex;
        width: 100%;

        .list {
            // cccccc
            flex: 1;
            width: 120px;
            height: 110px;
            background: rgba(255, 255, 255, 1);
            box-sizing: border-box;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: rgba(255, 255, 255, 0.16);
            color: #333333;
            font-size: 24px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .icon {
                width: 40px;
                height: 40px;
                margin-bottom: 5px;

                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }

        .selList {
            font-size: 24px;
            color: #FFFFFF;
            background: #003089;
            box-sizing: border-box;
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: rgba(255, 255, 255, 0.16);
        }
    }

    .chatBox {
        color: #2268EB;
        font-size: 15px;
        padding: 20px 30px;
        font-size: 40px;
        line-height: 1;
        border-radius: 15px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
        position: fixed;
        right: 50%;
        top: 50%;
        z-index: 9999;
        transform: translate(50%, -50%);
    }

    .mailBox {
        right: 50%;
    }

    .messageBox {
        right: 50%;
    }

    .telBox {
        right: 50%;
    }

    .whatsappBox {
        padding: 10px;
        border-radius: 15px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
        position: fixed;
        right: 50%;
        top: 50%;
        z-index: 9999;
        transform: translate(50%, -50%);

        img {
            width: 300px;
            height: 300px;
        }
    }

    .wechatBox {
        padding: 10px;
        border-radius: 15px;
        background: #FFFFFF;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
        position: fixed;
        right: 50%;
        top: 50%;
        z-index: 9999;
        transform: translate(50%, -50%);

        img {
            width: 300px;
            height: 300px;
        }
    }

}
</style>